export enum ViewOptions {
  SOURCE_FIELD = 'SOURCE_FIELD',
  SINGLE_OPERATION = 'SINGLE_OPERATION',
}

export enum SortOptions {
  ALPHABETICAL_AZ = 'ALPHABETICAL_AZ',
  ALPHABETICAL_ZA = 'ALPHABETICAL_ZA',
  CHRONOLOGICALLY_NEWEST = 'CHRONOLOGICALLY_NEWEST',
  CHRONOLOGICALLY_OLDEST = 'CHRONOLOGICALLY_OLDEST',
}

export const SORT_BY_OPTIONS = {
  alphabetical: 'FIELD_NAME',
  chronologically: 'START_DATE',
} as const;

export const SORT_PARAMS = {
  [SortOptions.ALPHABETICAL_AZ]: {
    sort_by: SORT_BY_OPTIONS.alphabetical,
    order: 'asc',
  },
  [SortOptions.ALPHABETICAL_ZA]: {
    sort_by: SORT_BY_OPTIONS.alphabetical,
    order: 'desc',
  },
  [SortOptions.CHRONOLOGICALLY_NEWEST]: {
    sort_by: SORT_BY_OPTIONS.chronologically,
    order: 'desc',
  },
  [SortOptions.CHRONOLOGICALLY_OLDEST]: {
    sort_by: SORT_BY_OPTIONS.chronologically,
    order: 'asc',
  },
};

export const VIEW_OPTIONS = [
  {
    label: 'field_matching.operation_list.view_options.source_field',
    value: ViewOptions.SOURCE_FIELD,
  },
  {
    label: 'field_matching.operation_list.view_options.single_operation',
    value: ViewOptions.SINGLE_OPERATION,
  },
];

export const SORT_OPTIONS = [
  {
    title: 'field_matching.operation_list.sort_options.alphabetical',
    label: 'A-Z',
    value: SortOptions.ALPHABETICAL_AZ,
  },
  {
    title: 'field_matching.operation_list.sort_options.alphabetical',
    label: 'Z-A',
    value: SortOptions.ALPHABETICAL_ZA,
  },
  {
    title: 'field_matching.operation_list.sort_options.chronologically',
    label: 'field_matching.operation_list.sort_options.newest',
    value: SortOptions.CHRONOLOGICALLY_NEWEST,
  },
  {
    title: 'field_matching.operation_list.sort_options.chronologically',
    label: 'field_matching.operation_list.sort_options.oldest',
    value: SortOptions.CHRONOLOGICALLY_OLDEST,
  },
];

export const VIEW_OPTIONS_VALUES = VIEW_OPTIONS.map((option) => option.value);

export const SORT_OPTIONS_VALUES = SORT_OPTIONS.map((option) => option.value);
